import { ProfileMapper } from '../../common/mappers/ProfileMapper';
import { GQLIdEncoder } from '../../common/utils/GQLIdEncoder';
import { Project } from '../models/Project';
import { UserMapper } from './UserMapper';

export class ProjectMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();
  readonly profileMapper = new ProfileMapper();
  readonly userMapper = new UserMapper();

  mapGQLModel(data: any): Project {
    const defaultProfile = data.defaultProfile ? this.profileMapper.mapGQLModel(data.defaultProfile) : null;
    const testers = data.testers ? data.testers.edges.map((edge: any) => this.userMapper.mapGQLModel(edge.node)) : [];
    return new Project(this.gqlIdEncoder.decode(data.id), data.name, data.description || null, defaultProfile, data.maxItemCount, testers);
  }
}
